<template>
    <AppModal ref="filtersModal" :title="translate('labels.table_filters')">
        <div class="modal-body">
            <FormGroup :label="$t('labels.internalId')">
                <AppSelect
                    @update:model-value="selectedInternalId = $event"
                    :model-value="selectedInternalId?.key"
                    :selected-value="selectedInternalId?.label"
                    :options="internalIdOptions"
                    option-key="key"
                    option-value="label"
                    canBeEmpty
                />
            </FormGroup>
            <FormGroup :label="$t('labels.status')">
                <MultiAutoComplete
                    v-model="statuses"
                    :url="generateUrl(`integrations/${integration.uuid}/order-statuses`, project.alias)"
                    option-value="value"
                />
            </FormGroup>
        </div>
        <div class="modal-footer">
            <AppButton size="sm" @click="apply" color="teal">{{ translate('buttons.apply') }}</AppButton>
        </div>
    </AppModal>
</template>
<script>
import FormGroup from "../../../../../../components/new/form/group/FormGroup.vue";
import AppSelect from "../../../../../../components/new/form/select/AppSelect.vue";
import MultiAutoComplete from "../../../../../../components/new/form/autocomplete/MultiAutoComplete.vue";
import AppModal from "../../../../../../components/new/modal/AppModal.vue";
import AppButton from "../../../../../../components/new/button/AppButton.vue";

import { mapGetters } from 'vuex';
import { generateUrl } from "../../../../../../utils";

export default {
    name: "IntegrationOrdersFiltersModal",
    components: {
        FormGroup, AppSelect, MultiAutoComplete, AppModal, AppButton
    },
    emits: ['update:filters'],
    props: {
        integration: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            generateUrl,
            statuses: [],
            selectedInternalId: null,
            internalIdOptions: [
                { key: 'present', label: this.$t('labels.present') },
                { key: 'missing', label: this.$t('labels.missing') },
            ]
        }
    },
    methods: {
        show() {
            this.$refs.filtersModal.show();
        },
        clear() {
            this.statuses = [];
            this.selectedInternalId = null;
            this.$emit('update:filters', { status_uuids: [] });
        },
        apply() {
            let filters = {
                status_uuids: this.statuses.map(status => status.uuid),
                selectedInternalId: this.selectedInternalId
            };
            
            this.$emit('update:filters', filters);
            this.$refs.filtersModal.hide();
        },
        getFilters() {
            let filters = {
                status_uuids: this.statuses.map(status => status.uuid)
            };

            if (this.selectedInternalId) {
                if (this.selectedInternalId.key === 'present') {
                    filters.has_order = 1;
                } else if (this.selectedInternalId.key === 'missing') {
                    filters.has_order = 0;
                }
            }

            return filters;
        }
    },
    computed: {
        ...mapGetters({
            project: 'route/project'
        })
    }
}
</script>
